import React from 'react';

export const commonKeyCodes = {
  escape: 27,
  enter: 13,
  ctrl: 17,
  space: 32,
};

function useKeyPress({
  targetKey,
  handler,
  onlyRunIf = true,
}: {
  targetKey: number;
  handler: Function;
  onlyRunIf: boolean;
}) {
  // state for keeping track of whether key is pressed
  const [keyPressed, setKeyPressed] = React.useState(false);

  // if pressed key is our target key the set to true
  function downHandler({ keyCode }) {
    if (keyCode === targetKey) {
      setKeyPressed(true);
      handler();
    }
  }

  // If released key is our target key then set to false
  function upHandler({ keyCode }) {
    if (keyCode === keyPressed) {
      setKeyPressed(false);
    }
  }

  // Add event listeners
  React.useEffect(() => {
    if (onlyRunIf) {
      window.addEventListener('keydown', downHandler);
      window.addEventListener('keyup', upHandler);
    }

    return () => {
      if (onlyRunIf) {
        window.removeEventListener('keydown', downHandler);
        window.removeEventListener('keyup', upHandler);
      }
    };
  }, [onlyRunIf]); // rebind events if onlyRunIf changes
}

export default useKeyPress;
